import React from 'react'
import { HightLight, Text } from '../gameRulesStyle'
import { InputWrapper, OperationWrapper, Roll } from './elements/ElementsStyles'
import Inputs from './elements/Input'
import OperationButtons from './elements/OperationButtons'
import PlayButton from './elements/PlayButton'
import SliderRange from './elements/Range'
import RollButtons from './elements/RollButtons'

export default function PlaceABet({ curr }: any) {
  return (
    <>
      <HightLight fontSize={'22px'} background={'red'} margin={'15px 0'}>
        How to place a bet?
      </HightLight>
      <Text>Just select the desired range of numbers</Text>
      <SliderRange />
      <Text margin={'30px 0 0'}>
        SET MULTIPLIER AND WIN CHANCE ADDITIONALLY
      </Text>
      <RollButtons />
      <InputWrapper>
        <Inputs label={'multiplier'} value={'6.15'} />
        <Inputs label={'win chance'} value={'16%'} />
      </InputWrapper>
      <Text margin={'30px 0 15px'}>
        ENTER DESIRED BET AND CONTROL ITS AMOUNT WITH ADDITIONAL{' '}
        <HightLight fontSize={'18px'} background='blue'>
          1/2
        </HightLight>{' '}
        and{' '}
        <HightLight fontSize={'18px'} background='red'>
          {' '}
          2x{' '}
        </HightLight>{' '}
        BUTTONS
      </Text>
      <OperationWrapper>
        <Inputs
          label={'bet amount'}
          value={curr + '10.22'}
          height={'50px'}
          fontSize={'24px'}
        />
        <OperationButtons />
      </OperationWrapper>
      <Text margin={'30px 0 15px'}>
        TO START GAME YOU CAN PRESS{' '}
        <HightLight fontSize={'18px'} background='green'>
          ROLL TO WIN{' '}
        </HightLight>{' '}
        BUTTON
      </Text>
      <PlayButton />
      <Text margin={'30px 0 15px'}>
        IN THE ROUND{' '}
        <HightLight fontSize={'18px'} background='blue'>
          HISTORY
        </HightLight>{' '}
        PAGE WE SHOW YOUR ROUND RESULT.
        <HightLight fontSize={'18px'} background='green'>
          WIN AMOUNT
        </HightLight>{' '}
        SHOWS YOUR FULL WIN AMOUNT. IN CASE IF THE ROUND WAS{' '}
        <HightLight fontSize={'18px'} background='red'>
          {' '}
          LOST - 0.00{' '}
        </HightLight>{' '}
        IS DISPLAYED IN THE{' '}
        <HightLight fontSize={'18px'} background='green'>
          WIN AMOUNT
        </HightLight>{' '}
        FIELD.
      </Text>
    </>
  )
}
